/**
 * Multi-institute support.
 *
 * A user (typically HR) can be assigned more than one institute. The institute
 * chosen in the sidebar selector is stored here and sent on every API request as
 * the `X-Entity-Id` header, so the backend scopes all data to that institute.
 */
const KEY = 'hrms-active-entity';

export const getActiveEntityId = () => {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
};

export const setActiveEntityId = (entityId) => {
  try {
    if (entityId) localStorage.setItem(KEY, entityId);
    else localStorage.removeItem(KEY);
  } catch { /* storage unavailable */ }
};

let installed = false;

export function installEntityHeaderInterceptor() {
  if (installed || typeof window === 'undefined' || !window.fetch) return;
  installed = true;
  const original = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const entityId = getActiveEntityId();
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (entityId && url.includes('/api/')) {
      const headers = new Headers((init && init.headers) || (input instanceof Request ? input.headers : undefined));
      headers.set('X-Entity-Id', entityId);
      return original(input, { ...init, headers });
    }
    return original(input, init);
  };
}
